module.exports = __webpack_public_path__ + "img/logo_1.4c30ad06.png";